import { useContext, useEffect, useState } from "react";

import { UserContext } from "../UserContext";
import { getInstructors } from "../api/instructorsService";

export function useResolvedInstructor() {
   const { user } = useContext(UserContext);
   const [instructor, setInstructor] = useState(null);
   const [resolved, setResolved] = useState(false);

   useEffect(() => {
      let cancelled = false;

      (async () => {
         if (!user || user.role !== "INSTRUCTOR") {
            setInstructor(null);
            setResolved(true);
            return;
         }

         setResolved(false);
         try {
            const all = await getInstructors();
            const mine = all.find((i) => String(i.userId) === String(user.id));
            if (!cancelled) {
               setInstructor(mine || null);
               setResolved(true);
            }
         } catch (e) {
            if (!cancelled) {
               setInstructor(null);
               setResolved(true);
            }
         }
      })();

      return () => {
         cancelled = true;
      };
   }, [user]);

   return { instructor, resolved, user };
}
